// Paper grain over the landscape only. The sky above stays clean, so it reads as pure light.
let grain: CanvasPattern | null = null;

function makeGrain(ctx: CanvasRenderingContext2D): CanvasPattern | null {
  const size = 160;
  const c = document.createElement('canvas');
  c.width = c.height = size;
  const g = c.getContext('2d');
  if (!g) return null;
  const img = g.createImageData(size, size);
  let seed = 99;
  for (let i = 0; i < img.data.length; i += 4) {
    seed = (seed * 1664525 + 1013904223) >>> 0;
    const v = (seed >>> 24) & 255;
    img.data[i] = img.data[i + 1] = img.data[i + 2] = v;
    img.data[i + 3] = 255;
  }
  g.putImageData(img, 0, 0);
  return ctx.createPattern(c, 'repeat');
}

/** `from` is the screen height fraction where the landscape (hills and below) begins; grain fades in just above it. */
export function finish(ctx: CanvasRenderingContext2D, w: number, h: number, from: number): void {
  if (!grain) grain = makeGrain(ctx);
  if (!grain) return;
  ctx.save();
  ctx.globalCompositeOperation = 'soft-light';
  ctx.fillStyle = grain;
  const bands = 6;
  const y0 = h * (from - 0.06);
  const y1 = h * from;
  for (let i = 0; i < bands; i++) {
    const ya = y0 + ((y1 - y0) * i) / bands;
    ctx.globalAlpha = (0.1 * (i + 1)) / bands;
    ctx.fillRect(0, ya, w, i === bands - 1 ? h - ya : (y1 - y0) / bands + 1);
  }
  ctx.restore();
}
